import { render } from "./IllustrationsManager.vue?vue&type=template&id=a2079c20"
import script from "./IllustrationsManager.vue?vue&type=script&lang=js"
export * from "./IllustrationsManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__